module.exports = __webpack_public_path__ + "static/media/up.758d86bc.svg";